import React, { useEffect, useState } from "react";
import { Table, Select, Modal, Button, Flex, Upload, message, Space, Popconfirm, Typography, Tooltip, Input, Image, Spin, Tag, Card, List } from "antd";
import { InboxOutlined, CloseOutlined, EditOutlined, UploadOutlined, DeleteOutlined, EyeOutlined, LoginOutlined, DollarCircleOutlined, ClockCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { decryptCredentials, downloadFileHandle } from "../../utils/commonFunc";
import UserEdit from "./UserEdit";
import axios from "axios";
import dayjs from "dayjs";
import { LocalStorageService } from "../../services/LocalStorage";

const { Dragger } = Upload;

function UsersList({ isLoading }) {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const [isEditModal, setIsEditModal] = useState(false);
  const [editData, seteditData] = useState(null);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [fileNames, setFileNames] = useState({});
  const [uploading, setUploading] = useState(false);
  const [uploadingRowId, setUploadingRowId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [selectedProductData, setSelectedProductData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [CountData, setCountData] = useState(0);
  const [isReferredUsersModalOpen, setIsReferredUsersModalOpen] = useState(false);
  const [referredUsers, setReferredUsers] = useState([]);
  const [loadingReferredUsers, setLoadingReferredUsers] = useState(false);
  const [selectedReferrals, setSelectedReferrals] = useState([]);
  const [markingAsPaid, setMarkingAsPaid] = useState(false);
  const [earnings, setEarnings] = useState({});
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
  const [currentSubscriptions, setCurrentSubscriptions] = useState([]);
  const paginationLimit = 10;

  useEffect(() => {
    fetchList();
  }, [page]);

  const handleFileNameChange = (name, fileId) => {
    setFileNames((prev) => ({ ...prev, [fileId]: name }));
  };

  const openProductModal = (user) => {
    setSelectedProductData(user);
    setIsProductModalOpen(true);
  };

  const fetchUserEarnings = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}commission/commission-earning/${userId}/REFERRAL`,
        {
          headers: { 
            'x-product-type': 'PIP_GRID',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('userToken')}`
          }
        }
      );
      if (response.data && response.data.success) {
        setEarnings(response.data.payload)
      }
    } catch (error) {
      console.error('Error fetching user earnings:', error);
    }
  };

  const showReferredUsers = async (userId) => {
    try {
      setLoadingReferredUsers(true);
      
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}admin/user-referral/${userId}/REFERRAL`,
        {
          headers: { 
            'x-product-type': 'PIP_GRID',
            'Content-Type': 'application/json'
          }
        }
      );

      setSelectedUser(userId);
      if (response.data && response.data.success) {
        const referredUsers = response.data.payload.data || [];
        setReferredUsers(referredUsers);
      } else {
        setReferredUsers([]);
      }
      fetchUserEarnings(userId);
      setIsReferredUsersModalOpen(true);
    } catch (error) {
      console.error("Error fetching referred users:", error);
      message.error("Failed to fetch referred users");
    } finally {
      setLoadingReferredUsers(false);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "count",
      key: "count",
      fixed: "left",
      width: "50px",
    },
    {
      title: "Name",
      key: "fullname",
      dataIndex: "fullname",
      width: "200px",
      fixed: "left",
    },
    {
      title: "Mail",
      dataIndex: "email",
      key: "mail",
      width: "250px",
      fixed: "left",
    },
    // {
    //   title: "Status",
    //   key: "status",
    //   dataIndex: "status",
    //   render: (e, rec) => (
    //     <>
    //       <Select
    //         defaultValue={e}
    //         value={e}
    //         style={{ width: "100%" }}
    //         onChange={(val) => statusChange(val, rec)}
    //         options={[
    //           { value: "ACTIVE", label: "Activate" },
    //           { value: "INACTIVE", label: "Inactivate" },
    //         ]}
    //       />
    //     </>
    //   ),
    //   width: "140px",
    // },
    {
      title: "User Code",
      dataIndex: "userCode",
      key: "userCode",
      width: "120px",
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      width: "220px",
      render: (e, rec) => (
        <Space>
          {console.log("🚀 ~ rec:", rec._id)}
          <Tooltip title="View Referred Users">
            <Button
              type="default"
              icon={<EyeOutlined />}
              size={"middle"}
              onClick={() => showReferredUsers(rec.id)}
            />
          </Tooltip>
          <Tooltip title="Login">
            <Button type="default" icon={<LoginOutlined />} size={"middle"} onClick={() => loginHandle(rec)} />
          </Tooltip>
          <Button
            type={rec.uploadedFiles && rec.uploadedFiles.length > 0 ? "primary" : "default"}
            icon={<UploadOutlined />}
            size={"middle"}
            onClick={() => uploadOpen(rec)}
          />
          <Button
            type="default"
            icon={<EditOutlined />}
            size={"middle"}
            onClick={() => {
              seteditData(rec);
              setIsEditModal(true);
            }}
          />
          <Popconfirm description="Are you sure you want to close this account ?" okText="Yes" cancelText="No" onConfirm={() => deleteUser(rec.key)}>
            <Tooltip title="Deactivate account status to close this account">
              <Button icon={<CloseOutlined />} danger size={"middle"} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
    // {
    //   title: "Plan ID",
    //   dataIndex: "planId",
    //   key: "planId",
    //   align: "center",
    //   width: "180px",
    // },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      width: "180px",
     render: (method) => method ? method.replace(/_/g, ' ') : '-'
    },
    {
      title: "Subscriptions",
      dataIndex: "subscriptions",
      key: "subscriptions",
      width: "80px",
      fixed: "left",
      render: (_, rec) => (
        <Button
          icon={<EyeOutlined />}
          onClick={() => {
            setCurrentSubscriptions(rec.subscriptions || []);
            setIsSubscriptionModalOpen(true);
          }}
        />
      )
    },
    {
      title: "Phone number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: "150px",
    },
    {
      title: "Date of Birth",
      dataIndex: "dob",
      key: "dob",
      width: "130px",
    },
    {
      title: "Password",
      dataIndex: "password",
      key: "password",
      width: "150px",
    },
    {
      title:"Total Amount",
      dataIndex:"totalAmount",
      key:"totalAmount",
      width:"150px",
      render: (amount) => (amount && typeof amount === 'number') ? `$${amount.toFixed(2).toString()}` : '-'
    },
    {
      title: "Plan Quantity",
      dataIndex: "planQuantity",
      key: "planQuantity",
      width: "150px",
      render: (quantity) => {
        console.log('Plan Quantity:', quantity);
        return quantity !== undefined ? quantity : '-';
      },
    },
    {
      title:"USDT Discount",
      dataIndex:"usdtDiscount",
      key:"usdtDiscount",
      width:"150px",
      render: (usdtDiscount) => (usdtDiscount && typeof usdtDiscount === 'number') ? `$${usdtDiscount.toFixed(2).toString()}` : '-'
    },
    {
      title:"Discount",
      dataIndex:"discountAmount",
      key:"discountAmount",
      width:"150px",
      render: (discount) => (discount && typeof discount === 'number') ? `$${discount.toFixed(2).toString()}` : '-'
    },
    // {
    //   title: "Days Remaining",
    //   dataIndex: "daysRemaining",
    //   key: "daysRemaining",
    //   width: "140px",
    //   render: (days, rec) => {
    //     if (!rec.uploadedFiles || rec.uploadedFiles.length === 0) {
    //       return <span>-</span>;
    //     }
    //     return <span>{days} Days</span>;
    //   },
    // },
    // ...["PG Gold", "PG Silver", "PG Platinum"].map((product) => ({
    //   title: product,
    //   key: product,
    //   dataIndex: "accountDetails",
    //   width: "170px",
    //   align: "center",
    //   render: (accountDetails, record) => {
    //     const normalize = (str) => str?.trim().replace(/\s+/g, " ");
    //     const isComboProduct = normalize(record.productName) === "Combo";

    //     const matchedAccount = accountDetails?.find((acc) => normalize(acc.productName) === normalize(product));

    //     if (isComboProduct) {
    //       return (
    //         <Tooltip title={matchedAccount ? "View Product Details" : "No account details available"}>
    //           <Button
    //             icon={<InboxOutlined />}
    //             type={matchedAccount ? "primary" : "default"}
    //             onClick={() => matchedAccount && openProductModal(matchedAccount)}
    //           />
    //         </Tooltip>
    //       );
    //     } else {
    //       const isUsersProduct = normalize(record.productName) === normalize(product);
    //       return isUsersProduct ? (
    //         <Tooltip title="View Product Details">
    //           <Button
    //             icon={<InboxOutlined style={{ lineHeight: 1 }} />}
    //             type={matchedAccount ? "primary" : "default"}
    //             onClick={() => matchedAccount && openProductModal(matchedAccount)}
    //           />
    //         </Tooltip>
    //       ) : (
    //         "-"
    //       );
    //     }
    //   },
    // })),
    {
      title: "Paid Amount($)",
      dataIndex: "paidAmount",
      key: "paidAmount",
      width: "180px",
      align: "center",
      render: (amount) => (amount && typeof amount === 'number') ? `$${amount.toFixed(2)}` : '-'
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: "180px",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      width: "180px",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      width: "180px",
    },
  ].filter(Boolean);

  const uploadOpen = (rec) => {
    setSelectedUser(rec);
    setIsUploadOpen(true);
    getUploadedFiles(rec);
  };

  const statusChange = (val, rec) => {
    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_ADMIN_API_URL}admin/update-status`,
        {
          userId: rec?.key,
          status: val,
        },
        {
          headers: {
            "x-product-type": "PIP_GRID",
          },
        }
      )
      .then((res) => {
        message.success(res.data.message || "Status updated successfully!");
        fetchList({});
        setLoading(false);
      })
      .catch((e) => {
        message.error(e.message || "An error occurred");
      });
  };

  const getDaysRemainingFromFiles = (uploadedFiles) => {
    if (!uploadedFiles || uploadedFiles.length === 0) return 365;

    const uploadedDates = uploadedFiles.map((file) => new Date(file.uploadedAt));
    const earliestUpload = new Date(Math.min(...uploadedDates));

    const completionDate = new Date(earliestUpload);
    completionDate.setFullYear(completionDate.getFullYear() + 1);

    const now = new Date();
    const diff = completionDate - now;

    return Math.max(Math.ceil(diff / (1000 * 60 * 60 * 24)), 0); // Ensures non-negative values
  };

  const fetchList = async () => {
    setLoading(true);
  
    try {
      const { data: usersRaw } = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}admin/subscription-requests/approved?page=${page}&limit=${paginationLimit}`,
        {
          headers: { "x-product-type": "PIP_GRID" },
        }
      );
      console.log("🚀 ~ fetchList ~ usersRaw:", usersRaw);
  
      const usersWithFiles = await Promise.all(
        usersRaw?.data?.map(async (user, index) => {
          let uploadedFiles = [];
  
          try {
            const fileRes = await axios.get(
              `${process.env.REACT_APP_ADMIN_API_URL}admin/uploaded-files/${user._id}`,
              {
                headers: { "x-product-type": "PIP_GRID" },
              }
            );
            uploadedFiles = fileRes.data?.user?.uploadedFiles || [];
          } catch (err) {
            console.warn(`Error fetching files for user ${user._id}`);
          }
  
          const decryptedPassword =
            user?.hashedPassword && user?.salt
              ? decryptCredentials(user?.salt, user?.hashedPassword)
              : "-";
  
          const daysRemaining = getDaysRemainingFromFiles(uploadedFiles);
          
          // Get the latest subscription
          const latestSubscription = user?.subscriptions?.length > 0 
            ? user.subscriptions[0] 
            : {};
  
          return {
            id: user?._id,
            count: index + 1,
            key: user?._id,
            fullname: user?.fullName || "-",
            phoneNumber: user?.phoneNumber || "-",
            dob: user?.dob ? dayjs(user?.dob).format("DD-MM-YYYY") : "-",
            email: user?.email || "-",
            loginRequestStatus: user?.loginRequestStatus || "APPROVED",
            status: user?.status || "ACTIVE",
            city: user?.city || "-",
            state: user?.state || "-",
            country: user?.country || "-",
            password: decryptedPassword,
            productName: user?.productName || "PIP_GRID",
            accountDetails: user?.accountDetails || [],
            transactionFiles: user?.transactionFiles || [],
            userCode: user?.userCode || "-",
            daysRemaining,
            uploadedFiles,
            planId: latestSubscription?.planId || "-",
            paymentStatus: latestSubscription?.status || "-",
            paymentMethod: latestSubscription?.paymentMethod || "-",
            planQuantity: latestSubscription?.planQuantity || "-",
            subscriptionDate: latestSubscription?.createdAt 
              ? dayjs(latestSubscription.createdAt).format("DD-MM-YYYY") 
              : "-",
            referredBy: user?.referralInfo?.refferedBy?.fullName || "-",
            referralCode: user?.referralInfo?.refferalCode || "-",
            paidAmount: user?.subscriptions?.[0]?.paidAmount || "-",
            discountAmount: user?.subscriptions?.[0]?.discountAmount || "-",
            totalAmount: user?.subscriptions?.[0]?.planPrice || "-",
            subscriptions: user?.subscriptions,
            usdtDiscount: user?.subscriptions?.[0]?.usdtDiscount || "-",
          };
        })
      );
  
      setUserList(usersWithFiles);
      setCountData(usersRaw?.count || 0);
    } catch (error) {
      console.error("Error fetching users:", error);
      message.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };
  const deleteUser = (id) => {
    setLoading(true);

    axios
      .delete(`${process.env.REACT_APP_ADMIN_API_URL}admin/delete-user/${id}`, {
        headers: {
          "x-product-type": "PIP_GRID",
        },
      })
      .then((res) => {
        fetchList({});
        setLoading(true);

        message.success(res.data.message || "User Deleted");
      })
      .catch((e) => {
        message.error(e.message);
      });
  };

  const aggregatedSubscriptions = Object.values(currentSubscriptions.reduce((acc, item) => {
        const planId = item?.planId?.[0]?._id || item?.planId?.[0]?.name;
        if (!acc[planId]) {
            acc[planId] = { ...item, totalQuantity: 0 };
        }
        acc[planId].totalQuantity += (item.planQuantity || 0);
        return acc;
    }, {}));

  const handleChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const handleUpload = (singleFile = null, planId = null, planName = null, rowKey = null) => {
    if (!singleFile && fileList.length === 0) {
      message.warning("Please select a file to upload.");
      return;
    }

    if (rowKey) setUploadingRowId(rowKey);
    setUploading(true);
    const formData = new FormData();
    if (singleFile) {
      formData.append("planIds[]", planId);
      formData.append("planNames[]", planName);
      formData.append("files", singleFile);
      formData.append("fileNames[]", singleFile.name);
    } else {
      fileList.forEach((file) => {
        formData.append("planIds", planId);
        formData.append("planNames", planName);
        formData.append("files", file.originFileObj);
        formData.append("fileNames", fileNames[file.uid] || file.name);
      });
    }

    axios
      .post(`${process.env.REACT_APP_ADMIN_API_URL}admin/upload-file/${selectedUser?.key}`, formData, {
        headers: {
          "x-product-type": "PIP_GRID",
        },
      })
      .then(() => {
        message.success(singleFile ? `File uploaded for ${planName}` : "Files uploaded successfully");
        if (!singleFile) setIsUploadOpen(false);
        setFileList([]);
        setFileNames({});
        getUploadedFiles(selectedUser);
      })
      .catch((e) => message.error("File upload failed"))
      .finally(() => {
        setUploading(false);
        setUploadingRowId(null);
      });
  };

  const getUploadedFiles = (rec) => {
    axios
      .get(`${process.env.REACT_APP_ADMIN_API_URL}admin/uploaded-files/${rec?.key}`, {
        headers: {
          "x-product-type": "PIP_GRID",
        },
      })
      .then((res) => {
        setExistingFiles(res.data.user.uploadedFiles || []);
        fetchList({});
      })
      .catch((e) => message.error("Error fetching uploaded files"));
  };

  const handleDeleteFile = (file) => {
    if (!file) {
      message.error("Invalid file.");
      return;
    }

    if (file.uid) {
      setFileList((prevList) => prevList.filter((f) => f.uid !== file.uid));
      message.success("File removed from upload queue.");
      return;
    }

    if (file._id && selectedUser?.key) {
      setDeletingId(file._id);
      axios
        .delete(`${process.env.REACT_APP_ADMIN_API_URL}admin/delete-file/${selectedUser.key}/${file._id}`, {
          headers: {
            "x-product-type": "PIP_GRID",
          },
        })
        .then((res) => {
          message.success(res.data.message || "File deleted successfully");
          setExistingFiles((prevFiles) => prevFiles.filter((f) => f._id !== file._id));
        })
        .catch((error) => {
          message.error(error.response?.data?.error || "Failed to delete the file");
          console.error("Error deleting file:", error);
        })
        .finally(() => setDeletingId(null));
    }
  };

  const loginHandle = (rec) => {
    axios
      .get(`${process.env.REACT_APP_ADMIN_API_URL}admin/generate-token/${rec.key}`, {
        headers: {
          "x-product-type": "PIP_GRID",
        },
      })
      .then((res) => {
        const token = res.data.token;
        LocalStorageService.setItem("userToken", token);
        // window.open(`http://localhost:3000/dashboard?token=${token}`, "_blank");
        window.open(`${process.env.REACT_APP_USER_BASE_URL}/dashboard?token=${token}`, "_blank");
      })
      .catch((e) => {
        message.error(e.response?.data?.message || "Login failed");
        console.error(e);
      });
  };
  const handlePagination = (pageNum) => {
    setPage(pageNum);
    fetchList(pageNum);
  };

  const handleMarkAsPaid = async () => {
    try {
      setMarkingAsPaid(true);
      console.log('Selected Referral IDs:', selectedReferrals);
      // Here you would typically make an API call to update the status of selected referrals
      // Example:
      await axios.post(
        `${process.env.REACT_APP_ADMIN_API_URL}commission/commissionpaid`,
        { commissionIds: selectedReferrals },
        {
          headers: { 'x-product-type': 'PIP_GRID',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('userToken')}`
           },
        }
      );
      message.success('Selected referrals marked as paid successfully');
      setSelectedReferrals([]);
      showReferredUsers(selectedUser)
    } catch (error) {
      console.error('Error marking referrals as paid:', error);
      message.error('Failed to mark referrals as paid');
    } finally {
      setMarkingAsPaid(false);
    }
  };
  const rowSelection = {
    selectedRowKeys: selectedReferrals,
    onChange: (selectedRowKeys) => {
      setSelectedReferrals(selectedRowKeys);
    },
    hideSelectAll: true, 
    columnTitle: null,   
    columnWidth: '50px', 
    renderCell: (_, record, index) => {
      if (record.commissionStatus === 'PAID') {
        return <span style={{ color: '#52c41a', fontSize: '16px', paddingLeft: '8px' }}>✓</span>;
      }

      return (
        <input
          type="checkbox"
          checked={selectedReferrals.includes(record._id)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedReferrals([...selectedReferrals, record._id]);
            } else {
              setSelectedReferrals(selectedReferrals.filter(id => id !== record._id));
            }
          }}
          style={{ marginLeft: '8px' }}
        />
      );
    },
  };

  console.log(earnings)

  return (
    <Spin spinning={loading} size="large">
      <Modal title="Upload File" open={isUploadOpen} onCancel={() => setIsUploadOpen(false)} footer={[]} width={800}>
        <Table
          columns={[
            {
              title: "Plan Name",
              dataIndex: "planName",
              key: "planName",
              width: "25%",
            },
            {
              title: "Price",
              dataIndex: "price",
              key: "price",
              width: "15%",
            },
            {
              title: "Upload",
              key: "upload",
              align: "center",
              width: "10%",
              render: (_, record) => {
                return (
                  <Upload
                    beforeUpload={(file) => {
                      handleUpload(file, record.planId, record.planName, record.key);
                      return false;
                    }}
                    showUploadList={false}
                    disabled={!!record.file || (uploadingRowId === record.key)}
                  >
                    <Button
                      loading={uploadingRowId === record.key}
                      disabled={!!record.file}
                      icon={!(uploadingRowId === record.key) && <UploadOutlined style={{ color: record.file ? "#999" : "black" }} />}
                      style={{
                        backgroundColor: record.file ? "#f5f5f5" : "#c1ff72",
                        borderColor: record.file ? "#d9d9d9" : "#c1ff72",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "30px",
                        width: "30px"
                      }}
                    />
                  </Upload>
                );
              },
            },
            {
              title: "Filename",
              key: "name",
              width: "35%",
              render: (_, record) => {
                const file = record.file;
                if (!file) return <span style={{ color: "#999" }}>No file uploaded</span>;
                const isExistingFile = !!file?._id;

                return (
                  <Input
                    defaultValue={file?.name || file?.fileName || "N/A"}
                    readOnly={isExistingFile}
                    onChange={(e) => !isExistingFile && handleFileNameChange(e.target.value, file.uid)}
                  />
                );
              },
            },
            {
              title: "Action",
              key: "action",
              align: "center",
              render: (_, record) => (
                <Flex align="center" gap={10} justify="center">
                  {record.file && (
                    <Button
                      type="link"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => handleDeleteFile(record.file)}
                      loading={deletingId === record.file?._id}
                    />
                  )}
                </Flex>
              ),
            },
          ]}
          dataSource={(() => {
            const allFiles = [...(existingFiles || []), ...(fileList || [])];
            const planDataSource = [];
            const matchedFileIds = new Set();

            // Group subscriptions by plan to handle total quantities correctly
            const aggregatedSubs = (selectedUser?.subscriptions || []).reduce((acc, sub) => {
              const plan = sub?.planId?.[0];
              const pId = plan?._id || plan?.name || "unknown";
              if (!acc[pId]) {
                acc[pId] = {
                  planId: pId,
                  name: plan?.name || "Plan",
                  price: `${plan?.price || "0"} ${plan?.currency || ""}`,
                  totalQty: 0
                };
              }
              acc[pId].totalQty += (sub.planQuantity || 0);
              return acc;
            }, {});

            Object.values(aggregatedSubs).forEach((plan) => {
              const quantity = plan.totalQty || 0;
              for (let i = 1; i <= quantity; i++) {
                const planNameWithIdx = `${plan.name} ${quantity > 1 ? `(${i})` : ""}`;

                // Find file matched by planId and specific indexed planName
                const matchingFile = allFiles.find(f =>
                  !matchedFileIds.has(f._id || f.uid) &&
                  (f.planId === plan.planId || f.planNames?.[0] === plan.name) &&
                  (f.planName === planNameWithIdx || f.planNames?.[0] === planNameWithIdx)
                );

                if (matchingFile) {
                  matchedFileIds.add(matchingFile._id || matchingFile.uid);
                }

                planDataSource.push({
                  key: `${plan.planId}-${i}`,
                  planName: planNameWithIdx,
                  price: plan.price,
                  planId: plan.planId,
                  file: matchingFile || null,
                });
              }
            });

            // Handle any files that didn't have matching meta-data
            allFiles.forEach((file) => {
              if (!matchedFileIds.has(file._id || file.uid)) {
                planDataSource.push({
                  key: file._id || file.uid || `extra-${Math.random()}`,
                  planName: "-",
                  price: "-",
                  planId: "",
                  file: file,
                });
              }
            });

            return planDataSource;
          })()}
          rowKey="key"
          style={{ marginTop: 16 }}
        />
      </Modal>

      <Typography.Title level={3} className="page-title">
        List
      </Typography.Title>

      <Flex justify="end" gap={5} style={{ marginBottom: "20px" }}>
        {/* <Input style={{ maxWidth: 200 }} placeholder="Search..." onChange={(e) => setSearchText(e.target.value)} /> */}
        {/* <Button type="primary" onClick={() => setFilterShow(!filterShow)}><FilterOutlined /></Button> */}
        {/* {(permission?.customer == "EDIT" || user?.role != "SUBADMIN") && <Button type="primary" onClick={showModal}>
										Create User
								</Button>} */}
        <Button type="primary" onClick={() => downloadFileHandle(userList, "users")}>
          Download
        </Button>
      </Flex>

      <Table
        columns={columns}
        dataSource={userList}
        scroll={{ x: 1500, y: 600 }}
        pagination={{
          current: page,
          pageSize: paginationLimit,
          total: CountData,
          onChange: handlePagination,
          showSizeChanger: false
        }}
        loading={loading}
        rowKey="_id"
      />

      <Modal
        title="Product Details"
        open={isProductModalOpen}
        closeIcon={false}
        footer={[
          <Button key="close" onClick={() => setIsProductModalOpen(false)}>
            Close
          </Button>,
        ]}
      >
        {selectedProductData && (
          <div>
            <p style={{ paddingBottom: "4px" }}>
              <strong style={{ paddingRight: "4px" }}>Account Name:</strong> {selectedProductData.accountName || "-"}
            </p>
            <p style={{ paddingBottom: "4px" }}>
              <strong style={{ paddingRight: "4px" }}>Broker Name:</strong> {selectedProductData.brokerName || "-"}
            </p>
            <p style={{ paddingBottom: "4px" }}>
              <strong style={{ paddingRight: "4px" }}>Balance:</strong> {selectedProductData.balance || "-"}
            </p>
            <p style={{ paddingBottom: "4px" }}>
              <strong style={{ paddingRight: "4px" }}>Account Number:</strong> {selectedProductData.accountNumber || "-"}
            </p>
            <p style={{ paddingBottom: "4px" }}>
              <strong style={{ paddingRight: "4px" }}>Investor Password</strong> {selectedProductData.investorPassword || "-"}
            </p>
            <p style={{ paddingBottom: "4px" }}>
              <strong style={{ paddingRight: "4px" }}>Broker Server:</strong> {selectedProductData.brokerServer || "-"}
            </p>
          </div>
        )}
      </Modal>
      <Modal
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <span>Referred Users</span>
              <span>{referredUsers?.length > 0 ? (
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <Card
                    size="small"
                    style={{ background: '#f6ffed', borderColor: '#b7eb8f' }}
                    bodyStyle={{ padding: '4px 12px' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <DollarCircleOutlined style={{ color: '#52c41a' }} />
                      <span style={{ fontWeight: 500 }}>${earnings?.totalCommissionEarned || '0.00'}</span>
                      <span style={{ color: '#8c8c8c', fontSize: '12px', marginLeft: '4px' }}>TOTAL</span>
                    </div>
                  </Card>
                  <Card
                    size="small"
                    style={{ background: '#fff2f0', borderColor: '#ffccc7' }}
                    bodyStyle={{ padding: '4px 12px' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <ClockCircleOutlined style={{ color: '#ff4d4f' }} />
                      <span style={{ fontWeight: 500 }}>${earnings?.dueAmount || '0.00'}</span>
                      <span style={{ color: '#8c8c8c', fontSize: '12px', marginLeft: '4px' }}>UNPAID</span>
                    </div>
                  </Card>
                  <Card
                    size="small"
                    style={{ background: '#e6f7ff', borderColor: '#91d5ff' }}
                    bodyStyle={{ padding: '4px 12px' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <CheckCircleOutlined style={{ color: '#1890ff' }} />
                      <span style={{ fontWeight: 500 }}>${earnings?.paidAmount || '0.00'}</span>
                      <span style={{ color: '#8c8c8c', fontSize: '12px', marginLeft: '4px' }}>PAID</span>
                    </div>
                  </Card>
                </div>
              ) : ""}</span>
            </div>
            <Button
              type="primary"
              onClick={handleMarkAsPaid}
              disabled={selectedReferrals.length === 0 || markingAsPaid}
              loading={markingAsPaid}
              style={{ marginRight: '30px' }}
            >
              Mark as Paid
            </Button>
          </div>
        }
        open={isReferredUsersModalOpen}
        onCancel={() => {
          setIsReferredUsersModalOpen(false);
          setSelectedReferrals([]);
        }}
        footer={null}
        width={1000}
      >
        <Table
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }}
          columns={[
            {
              title: "Name",
              dataIndex: "fullName",
              key: "fullName",
            },
            {
              title: "Email",
              dataIndex: "email",
              key: "email",
            },
            {
              title: "Phone",
              dataIndex: "phoneNumber",
              key: "phoneNumber",
            },
            {
              title:"Commission",
              dataIndex:"commissionAmount",
              key:"commissionAmount"
            },
            {
              title: "Status",
              dataIndex: "commissionStatus",
              key: "commissionStatus",
              render: (commissionStatus) => (
                <Tag color={commissionStatus === 'PAID' ? 'green' : 'orange'}>
                  {commissionStatus}
                </Tag>
              ),
            },
            // {
            //   title: "Joined At",
            //   dataIndex: "joinedAt",
            //   key: "joinedAt",
            //   render: (date) => date ? dayjs(date).format("DD MMM YYYY, hh:mm A") : '-',
            // },
          ]}
          dataSource={referredUsers}
          rowKey="_id"
          pagination={false}
          loading={loadingReferredUsers}
          locale={{
            emptyText: "No referred users found",
          }}
        />
      </Modal>
      <Modal
                      title={<div style={{ marginBottom: "15px" }}>Subscription Details</div>}
                      open={isSubscriptionModalOpen}
                      onCancel={() => setIsSubscriptionModalOpen(false)}
                      footer={null}
                      centered
                      width={500}
                  >
                      <List
                          grid={{ gutter: 16, column: 2 }}
                          dataSource={aggregatedSubscriptions}
                          renderItem={(item) => (
                              <List.Item>
                                  <Card title={item?.planId?.[0]?.name || "Unknown Plan"} bordered={true}>
                                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                          <div><strong>Price:</strong> {item?.planId?.[0]?.price} {item?.planId?.[0]?.currency}</div>
                                          <div><strong>Quantity:</strong> {item?.totalQuantity}</div>
                                          <div><strong>Status:</strong> {item?.status}</div>
                                      </div>
                                  </Card>
                              </List.Item>
                          )}
                      />
                  </Modal>
      {isEditModal && <UserEdit editData={editData} isLoading={false} onClose={() => setIsEditModal(false)} fetchList={fetchList} type="list" />}
    </Spin>
  );
}
const mapStateToProps = ({ loading }) => {
  const { isLoading } = loading;
  return { isLoading };
};
export default connect(mapStateToProps, {})(UsersList);
